import { render, staticRenderFns } from "./GraphEditorArrow.vue?vue&type=template&id=188bfff2&scoped=true"
import script from "./GraphEditorArrow.vue?vue&type=script&lang=js"
export * from "./GraphEditorArrow.vue?vue&type=script&lang=js"
import style0 from "./GraphEditorArrow.vue?vue&type=style&index=0&id=188bfff2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188bfff2",
  null
  
)

export default component.exports